module.exports = __webpack_public_path__ + "static/media/brazilian.51ea567c.jpg";